module.exports = __webpack_public_path__ + "static/media/FontAwesome.b06871f2.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf
// module id = 1251
// module chunks = 0